import { useEffect, useRef, useState } from 'react';

// Padel point order, so 30 → 40 reads as "up" and 40 → 30 (undo) as "down".
const POINT_ORDER = { '0': 0, '15': 1, '30': 2, '40': 3, AD: 4, A: 4 };
const rank = (value) => {
  const key = String(value ?? '').trim().toUpperCase();
  if (key in POINT_ORDER) return POINT_ORDER[key];
  const n = parseFloat(key);
  return Number.isFinite(n) ? n : 0;
};

/**
 * Score that rolls like an odometer when it changes: up for a point won, down for an undo,
 * and a soft scale/fade when a new game starts (`resetKey` changes).
 * Both values sit in the same grid cell so layout never jumps.
 * `team` (1 or 2) tags the live point score so the multi-device simulator can read what's on screen.
 */
export default function AnimatedScore({ value, resetKey, className = '', style, team }) {
  const [frames, setFrames] = useState({ current: value, previous: null, dir: null, id: 0 });
  const lastRef = useRef({ value, resetKey });

  useEffect(() => {
    const last = lastRef.current;
    if (String(last.value) === String(value) && last.resetKey === resetKey) return;
    let dir = rank(value) >= rank(last.value) ? 'up' : 'down';
    if (last.resetKey !== resetKey) dir = 'reset';
    lastRef.current = { value, resetKey };
    setFrames((f) => ({ current: value, previous: f.current, dir, id: f.id + 1 }));
  }, [value, resetKey]);

  const { current, previous, dir, id } = frames;
  return (
    <span className={`score-roll ${className}`} style={style} data-score-team={team}>
      {previous !== null && dir && (
        <span key={`out-${id}`} className={`score-roll__out score-roll--${dir}`} aria-hidden="true">
          {previous}
        </span>
      )}
      <span key={`in-${id}`} className={`score-roll__in ${dir ? `score-roll--${dir}` : ''}`}>
        {current}
      </span>
    </span>
  );
}
